export const DOMAIN_VALUE_PREFIX = 'DV';
export const DOMAIN_VALUE_BOOLEAN = `${DOMAIN_VALUE_PREFIX}-BOOLEAN`;

export const TABLE_ID_SUFFIX = 'Table';

export const ACTION_TYPES = {
  SET: 'set',
  UNSET: 'unset',
  LOG: 'log',
  ALERT: 'alert',
  CONFIRM: 'confirm',
  INCREMENT: 'increment',
  DECREMENT: 'decrement',
  NEW_ENTRY: 'newEntry',
  EDIT_ENTRY: 'editEntry',
  DELETE_ENTRY: 'deleteEntry',
  SAVE_ENTRY: 'saveEntry',
  ROLLBACK_ENTRY_TO_DRAFT: 'rollbackEntryToDraft',
  CLEAR_ENTRIES: 'clearEntries',
  OPEN_MODAL: 'openModal',
  CLOSE_MODAL: 'closeModal',
  COMPUTE_ALLOCATION: 'computeAllocation',
  SAVE_ALLOCATION: 'saveAllocation',
  CANCEL_ALLOCATION: 'cancelAllocation',
  FILL_OCR: 'fillOcr',
  ARRAY_SET: 'arraySet',
  BATCH: 'batch',
} as const;

export const MAX_AMOUNT = 9999999.99;

export const CURRENT_YEAR_TOKEN = 'currentYear' as const;
export type CurrentYearToken = typeof CURRENT_YEAR_TOKEN;

export const TEXT_INPUT_LENGTHS = {
  EXTRA_SHORT: 6,
  SHORT: 10,
  MEDIUM: 25,
  MEDIUM_LONG: 30,
  LONG: 40,
  ADDRESS: 54,
  EXTRA_LONG: 60,
  CUSTOM: (max: number) => max,
  BANK_FIELDS: {
    TRANSIT: 5,
    INSTITUTION: 3,
    ACCOUNT: 12,
    ACCOUNT_MIN: 4,
  },
} as const;

export const CANADIAN_POSTAL_CODE_REGEXP = '^[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]$';
export const ALL_CAPS_CANADIAN_POSTAL_CODE_REGEXP = '^[A-Z][0-9][A-Z] [0-9][A-Z][0-9]$';

export enum INVESTMENT_ACCOUNT_DATA_TYPES {
  CIQ = 'dailyInterestAccounts',
  CIG = 'guaranteedInterestAccounts',
  CI = 'benevaInvestmentAccounts',
  CHR = 'highYieldAccounts',
  FPG = 'benevaGuaranteedInvestmentFunds',
}

export enum BENEFICIARIES_ARRAY_TYPES {
  BEN = 'beneficiaries',
  COBEN = 'contigentBeneficiaries',
}

export type ARRAY_DATA_TYPES = INVESTMENT_ACCOUNT_DATA_TYPES | BENEFICIARIES_ARRAY_TYPES;
